/**
 * Shared geographic primitives.
 *
 * `GpsPoint` was originally introduced inside `contract/contract.ts`; it
 * now lives here so Customer (and any other aggregate that captures GPS
 * — LocationSignal, repossession events) can use the same shape and the
 * same Zod schema.
 */
import { z } from "zod";
export const gpsPointSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    accuracyMetres: z.number().nonnegative(),
});
//# sourceMappingURL=geo.js.map